import React, {useEffect, useState, useCallback, useRef} from 'react';
import AppForm from '../../../../../components/forms/AppForm';
import AppFormSelectField from '../../../../../components/forms/AppFormSelectField';
import {Column, Row} from '../../../../../components/layout';
import {
  addToWizard,
  setWizard,
  setIban,
  setTitular,
} from '../../../../../store/actions';
import {functionalitiesAliasMap, strings} from '../../../../../util/strings';
import * as Yup from 'yup';
import colors from '../../../../../util/colors';
import './styles.scss';
import {
  AppFormCheckboxField,
  AppFormDatePickerField,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {
  today,
  createCoveragesMap,
  getDateInServerFormat,
  toDataUrlAsync,
  appendFormData,
  getColor,
  deepStringObjectMerger,
} from '../../../../../util/utility';
import {Icons} from '../../../../../util/icons';
import Icon from '../../../../../components/icon';
import * as fonts from '../../../../../util/fonts';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {createGUID} from '../../../../../util/utility';
import AppFilePreview from '../../../../../components/app-drap-drop-file-input/app-file-preview';
import ModalTemplate from '../../../../../components/modal';
import Header2 from '../../../../../components/headers/header2';
import AppDragDropFileInput from '../../../../../components/app-drap-drop-file-input';
import moment from 'moment';
import {
  uriGetTitular,
  uriIreneCoverages,
  uriMemberData,
  uriNewExpenseSubmitionToAdvSystem,
} from '../../../../../api/endpoints';
import {
  get,
  configsAcceptLanguage,
  postWithCustomHeaders,
} from '../../../../../api/api';
import {useHistory} from 'react-router-dom';
import AppButton from '../../../../../components/app-button';
import {FieldArray} from 'formik';
import AppSpinner from '../../../../../components/app-spinner';
import {useMediaQuery} from 'react-responsive';
import AppRadioSelectInput from '../../../../../components/input/app-radio-select-input';
import {formatCurrencyExpenses} from '../../../../../util/utility';

export interface NewReimbursementDataProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  wizard: any;
  setWizard(value: any): void;
  setIban(value: any): void;
  setTitular(value: any): void;
  addToWizard(value: any): void;
  buStyles: any;
  selectedBu: any;
  labels: typeof strings.pt.createRefund;
  messageLabels: typeof strings.pt.messages;
  ibanLabels: typeof strings.pt.ibanRefunds;
  user: any;
  setOldFiles: Function;
  oldFiles: any;
  patients: any;
  titular: any;
  busFuncMap: any;
  bankAccountDataHolder: any;
  iban: any;
  tenant: any;
}

function NewReimbursementData({
  setValid,
  labels,
  ibanLabels,
  wizard,
  setWizard,
  setOldFiles,
  oldFiles,
  buStyles,
  selectedBu,
  user,
  patients,
  titular,
  busFuncMap,
  bankAccountDataHolder,
  iban,
  tenant,
}: NewReimbursementDataProps) {
  const isServiaPortal = tenant?.country === 'RS';
  const createRefundLabels = deepStringObjectMerger({
    ...strings.pt.createRefund,
    ...labels,
  });
  const ibanStrings = deepStringObjectMerger({
    ...strings.pt.ibanRefunds,
    ...ibanLabels,
  });
  const [specificErrorMessage, setSpecificErrorMessage] = useState<any>();

  const preRefundFunc = busFuncMap[selectedBu.buId].find(
    (item: any) => item.featureTemplateAlias === 'pre-comparticipacao',
  );
  const preRefundFuncAtiva = preRefundFunc?.isVisible;

  // USED FOR THE DRAG AND DROP FILE INPUT
  const [submitCountForDND, setSubmitCountForDND] = useState(0);

  const [submitting, setSubmitting] = useState(false);
  const [patient, setPatient] = useState(patients);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [patientOptions, setPatientOptions] = useState<any[]>([]);
  const [invoiceFile, setInvoiceFile] = useState<any[]>([]);
  const [files, setFiles] = useState<any[]>([]);
  const [preRefundFiles, setPreRefundFiles] = useState<any[]>([]);
  const [expenses, setExpenses] = useState<any[]>([]);
  const [medicalProcedureDate, setMedicalProcedureDate] = useState<Date | null>(
    null,
  );
  const [errorShow, setErrorShow] = useState(false);
  const [modalErrorMessage, setModalErrorMessage] = useState('');
  const [procsToValidate, setProcsToValidate] = useState<any[]>([]);
  const [expensesLabels, setExpensesLabels] = useState<Set<string>>(
    new Set([]),
  );
  // const [expensesType, setExpensesType] = useState<Set<string>>(new Set([]));
  const [datePickerFloorError, setDatePicketFloorError] = useState(false);
  const [datePickerEmpty, setDatePickerEmpty] = useState(true);
  const [expensesLabel, setExpensesLabel] = useState('');
  const [coveragesMap, setCoveragesMap] = useState<any>({});
  const [coverageOptions, setCoverageOptions] = useState<any[]>([]);
  const [showRefundData, setShowRefundData] = useState(!preRefundFuncAtiva);
  const [knowMoreModal, setShowKnowMoreModal] = useState(false);
  const [displayIban, setDisplayIban] = useState(true);
  const [ibanMessage, setIbanMessage] = useState('');
  const [knowMoreMessage, setKnowMoreMessage] = useState('');
  const [preRefunded, setPreRefunded] = useState(false);
  // const [isIbanFilled, setIsIbanFilled] = useState(false);
  const [selectedPatientIban, setSelectedPatientIban] = useState(iban || '');
  const [showDeclarationInfo, setShowDeclarationInfo] = useState(false);
  const [showSpecificErrorMessageModal, setShowSpecificErrorMessageModal] =
    useState(false);

  /* ---------------------- VALIDATION SCHEMAS ------------------ */
  const expensesValidationSchema = Yup.object().shape({
    coverage: Yup.string()
      .typeError(createRefundLabels.createRefund_invalidInput)
      .required(createRefundLabels.createRefund_invalidInput),
    medicalAct: Yup.string()
      .typeError(createRefundLabels.createRefund_invalidInput)
      .required(createRefundLabels.createRefund_invalidInput),
    value: Yup.number()
      .typeError(createRefundLabels.createRefund_invalidInput)
      .required(createRefundLabels.createRefund_invalidInput)
      .moreThan(0, createRefundLabels.createRefund_invalidValue),
  });

  // NOTE: keeping the initialValidationSchema commented out just in case we need to revert to it
  // const initialValidationSchema = Yup.object().shape({
  //   patient: Yup.mixed().required(),
  //   dateOfOcurrence: Yup.date()
  //     .max(today(true))
  //     .min('1999-01-01')
  //     .typeError(createRefundLabels.createRefund_invalidInput),
  //   noDocuments: Yup.boolean()
  //     .required()
  //     .test(
  //       'files-or-checkbox',
  //       createRefundLabels.createRefund_invalidInput,
  //       function (value) {
  //         // Only validate when renderAddClinicInfo is rendered: preRefunded OR (!preRefunded && expensesLabel !== '')
  //         const shouldValidate =
  //           preRefunded || (!preRefunded && expensesLabel !== '');
  //         if (!shouldValidate) {
  //           return true;
  //         }
  //         // If there are files, validation passes regardless of checkbox state
  //         if (files.length > 0) {
  //           return true;
  //         }
  //         // If no files, checkbox must be checked (true)
  //         return value === true;
  //       }
  //     ),
  //   expenses: Yup.array().of(
  //     Yup.object().shape({
  //       coverage: Yup.string().required(
  //         createRefundLabels.createRefund_invalidInput
  //       ),
  //       medicalAct: Yup.string().required(
  //         createRefundLabels.createRefund_invalidInput
  //       ),
  //       value: Yup.number()
  //         .required(createRefundLabels.createRefund_invalidInput)
  //         .moreThan(0, createRefundLabels.createRefund_invalidValue),
  //     })
  //   ),
  //   termsAccepted: Yup.boolean()
  //     .required(createRefundLabels.createRefund_invalidInput)
  //     .oneOf([true], createRefundLabels.createRefund_invalidInput),
  // });

  const newValidationSchema = Yup.object().shape({
    patient: Yup.mixed().required(),
    dateOfOcurrence: Yup.date()
      .max(today(true))
      .min('1999-01-01')
      .typeError(createRefundLabels.createRefund_invalidInput),
    noDocuments: Yup.boolean()
      .required()
      .test(
        'files-or-checkbox',
        createRefundLabels.createRefund_invalidInput,
        function (value) {
          // Only validate for the regular (non-pre-refund) clinic info section
          const shouldValidate = !preRefunded && expensesLabel !== '';
          if (!shouldValidate) {
            return true;
          }
          // If there are files, validation passes regardless of checkbox state
          if (files.length > 0) {
            return true;
          }
          // If no files, checkbox must be checked (true)
          return value === true;
        },
      ),
    noDocumentsPreRefund: Yup.boolean()
      .required()
      .test(
        'prerefund-files-or-checkbox',
        createRefundLabels.createRefund_invalidInput,
        function (value) {
          // Only validate for the pre-refund clinic info section
          if (!preRefunded) {
            return true;
          }
          // If there are pre-refund files, validation passes
          if (preRefundFiles.length > 0) {
            return true;
          }
          // If no files, checkbox must be checked (true)
          return value === true;
        },
      ),
    expenses: Yup.array().of(
      Yup.object().shape({
        coverage: Yup.string().required(
          createRefundLabels.createRefund_invalidInput,
        ),
        medicalAct: Yup.string().required(
          createRefundLabels.createRefund_invalidInput,
        ),
        value: Yup.number()
          .required(createRefundLabels.createRefund_invalidInput)
          .moreThan(0, createRefundLabels.createRefund_invalidValue),
      }),
    ),
    termsAccepted: Yup.boolean()
      .required(createRefundLabels.createRefund_invalidInput)
      .oneOf([true], createRefundLabels.createRefund_invalidInput),
  });
  /* ---------------------- VALIDATION SCHEMAS END ------------------ */

  const [validationSchema, setValidationSchema] =
    useState<any>(newValidationSchema); // previsouly: initialValidationSchema (keeping it here just in case we need to change it back)
  const [formikContext, setFormikContext] = useState<any>();
  const formikContextRef = useRef<boolean>(false);
  const history = useHistory();

  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>([]);
  const [hoverErrorDateOfOcurrence, setHoverErrorDateOfOcurrence] =
    useState(false);
  const [noDocuments, setNoDocuments] = useState(false);
  const [noDocumentsPreRefund, setNoDocumentsPreRefund] = useState(false);
  const dateLimit = new Date('JAN 01 1998');

  const featureName = 'NewReimbursement';

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});

  const defineIbanMessage = () => {
    const isTitularLogged =
      bankAccountDataHolder === 'SUBSCRIBER'
        ? titular?.nif === user?.nif
        : true;

    const ibanFuncActive = busFuncMap[selectedBu.buId]?.find(
      (func: any) =>
        func.featureTemplateAlias === functionalitiesAliasMap.iban &&
        func.isVisible,
    );

    let filledIbanAux = false; //prevent timing errors with state variable

    if (bankAccountDataHolder === 'SUBSCRIBER') {
      filledIbanAux = titular?.iban;
    } else if (bankAccountDataHolder === 'INDIVIDUAL') {
      filledIbanAux = selectedPatientIban !== '';
    }
    // setIsIbanFilled(filledIbanAux);

    if (ibanFuncActive) {
      if (!filledIbanAux) {
        if (ibanStrings.ibanRefunds_ibanIsEnabled === '1') {
          if (bankAccountDataHolder === 'SUBSCRIBER') {
            setIbanMessage(
              isTitularLogged
                ? createRefundLabels.createRefund_step3_owner
                : createRefundLabels.createRefund_step3_not_owner,
            );
            setKnowMoreMessage(
              isTitularLogged
                ? createRefundLabels.createRefund_know_more_modal_text_ibanEnabled_owner
                : createRefundLabels.createRefund_know_more_modal_text_ibanEnabled_not_owner,
            );
          } else if (bankAccountDataHolder === 'INDIVIDUAL') {
            setKnowMoreMessage(
              createRefundLabels.createRefund_know_more_modal_text_ibanEnabled_not_owner,
            );
          }
        } else if (ibanStrings.ibanRefunds_ibanIsEnabled === '0') {
          setDisplayIban(false);
        }
      } else {
        setIbanMessage(titular.iban);
        if (ibanStrings.ibanRefunds_ibanIsEnabled === '1') {
          if (bankAccountDataHolder === 'SUBSCRIBER') {
            setKnowMoreMessage(
              isTitularLogged
                ? createRefundLabels.createRefund_know_more_modal_text_ibanEnabled_owner
                : createRefundLabels.createRefund_know_more_modal_text_ibanEnabled_not_owner,
            );
          } else if (bankAccountDataHolder === 'INDIVIDUAL') {
            setKnowMoreMessage(
              createRefundLabels.createRefund_know_more_modal_text_ibanEnabled_owner,
            );
          }
        } else if (ibanStrings.ibanRefunds_ibanIsEnabled === '0') {
          if (bankAccountDataHolder === 'SUBSCRIBER') {
            setKnowMoreMessage(
              isTitularLogged
                ? createRefundLabels.createRefund_know_more_modal_text_ibanDisabled_owner
                : createRefundLabels.createRefund_know_more_modal_text_ibanDisabled_not_owner,
            );
          } else if (bankAccountDataHolder === 'INDIVIDUAL') {
            setKnowMoreMessage(
              createRefundLabels.createRefund_know_more_modal_text_ibanDisabled_owner,
            );
          }
        }
      }
    } else {
      setDisplayIban(false);
    }
  };

  const defaultDateOfOccurence = wizard?.invoiceValidation?.docDate
    ? moment(wizard.invoiceValidation.docDate).isValid()
      ? moment(wizard.invoiceValidation.docDate).toDate()
      : medicalProcedureDate
    : medicalProcedureDate;

  useEffect(() => {
    var aux: any[] = [];
    expenses.forEach((element) => {
      // cloning the objects and removing any references
      var ob = Object.assign({}, element);
      aux.push(ob);
    });

    setHoverErrorIcons(aux);
    defineIbanMessage();
    updateExpensesLabels(expenses);
    if (formikContext) {
      (formikContext as any).setFieldValue('expenses', expenses);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expenses]);

  useEffect(() => {
    defineIbanMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient]);

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string,
    index: number,
    valueError?: boolean,
    dateOfOcurrence?: boolean,
  ) => {
    const elem: HTMLElement = e.target as HTMLElement;
    if (valueError) {
      const icon: HTMLElement = elem.nextSibling as HTMLElement;
      if (index > -1) defineIconFunctions(icon, fieldNamePar, index);
    }

    if (elem.tagName.includes('svg') || elem.tagName.includes('path')) {
      if (index > -1) defineIconFunctions(elem, fieldNamePar, index);
      else if (dateOfOcurrence) {
        if (elem) {
          elem.onmouseover = function () {
            if (datePickerFloorError || datePickerEmpty)
              setHoverErrorDateOfOcurrence(true);
          };
          elem.onmouseout = function () {
            setHoverErrorDateOfOcurrence(false);
          };
        }
      }
    }
  };

  const defineIconFunctions = (
    icon: HTMLElement,
    fieldNamePar: any,
    index: number,
  ) => {
    if (icon) {
      icon.onmouseover = function () {
        showErrorOnFieldHover(fieldNamePar, index, true);
      };
      icon.onmouseout = function () {
        showErrorOnFieldHover(fieldNamePar, index, false);
      };
    }
  };

  const handleDatePickerChange = (value: any) => {
    if (!value) {
      setDatePickerEmpty(true);
      setDatePicketFloorError(false);
    } else if (moment(value) < moment(dateLimit)) {
      setDatePicketFloorError(true);
      setDatePickerEmpty(false);
    } else {
      setDatePicketFloorError(false);
      setDatePickerEmpty(false);
    }
    setMedicalProcedureDate(value);
  };

  const handleFormikContext = useCallback((formik: any) => {
    if (!formikContextRef.current) {
      formikContextRef.current = true;
      setFormikContext(formik);
    }
  }, []);

  const showErrorOnFieldHover = (
    fieldNamePar: any,
    index: number,
    boolValue: boolean,
  ) => {
    var aux: any[] = [];
    var changedAux: any[] = [];

    if (hoverErrorIcons !== undefined) {
      Object.keys(hoverErrorIcons).forEach((item: any, i) => {
        changedAux = hoverErrorIcons[index];
        changedAux[fieldNamePar] = boolValue;

        aux.push(
          i === index
            ? !aux.includes(hoverErrorIcons[index])
              ? hoverErrorIcons[index]
              : null
            : hoverErrorIcons[item],
        );
      });
      setHoverErrorIcons(aux);
    }
  };

  const createMedicalActOptions = (
    coverage: string,
    customCoveragesMap?: any,
  ) => {
    const aux = customCoveragesMap ? customCoveragesMap : coveragesMap;
    return coverage !== ''
      ? aux && aux[`${coverage}`]
        ? aux[`${coverage}`].medicalActs.map((medicalAct: any) => ({
            value: medicalAct.procCode,
            label: medicalAct.procCodeDesc,
          }))
        : []
      : [];
  };

  const deleteProcess = async () => {
    setWizard({step: 0});
  };

  const updateExpensesLabels = (expenses: any[]) => {
    setExpensesLabels(
      new Set(
        expenses.map((elem) => {
          const coverage = coveragesMap[`${elem.coverage}`];
          if (coverage && coverage.medicalActs) {
            const medicalAct = coverage.medicalActs.find(
              (act: any) => act.procCode === elem.medicalAct,
            );
            return medicalAct && medicalAct.msg;
          }
          return null;
        }),
      ),
    );
    // setExpensesType(
    //   new Set(
    //     expenses.map((elem) => {
    //       const coverage = coveragesMap[`${elem.coverage}`];
    //       if (coverage && coverage.medicalActs) {
    //         const medicalAct = coverage.medicalActs.find(
    //           (act: any) => act.procCode === elem.medicalAct,
    //         );
    //         return medicalAct && medicalAct.type;
    //       }
    //       return null;
    //     }),
    //   ),
    // );
  };

  const getBase64FromInvoice = async (invoiceFiles: any) => {
    return new Promise(async (resolve, reject) => {
      const newInvoiceFiles: any = [];
      await invoiceFiles.forEach(async (file: any) => {
        await toDataUrlAsync(file.preview)
          .then(async (base64: any) => {
            let newFile = await {...file, preview: base64};
            newInvoiceFiles.push(newFile);
            if (invoiceFiles.length === newInvoiceFiles.length) {
              resolve(newInvoiceFiles);
            }
          })
          .catch((err: any) => {
            reject(err.toString());
          });
      });
    });
  };

  useEffect(() => {
    if (oldFiles.length > 0) {
      setInvoiceFile(oldFiles);
      setWizard({...wizard, files: oldFiles});
    } else {
      setOldFiles(wizard.files);
      setInvoiceFile(wizard.files);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldFiles]);

  function getPatientOptions() {
    const patientsList = patients.patients;

    var patientsOpt: any[] = [];
    (patientsList as any).forEach((patient: any) => {
      if (
        selectedBu.famId === patient.famId &&
        selectedBu.buId === patient.buId
      )
        patientsOpt.push(patient);
    });

    setPatientOptions(
      (patientsOpt as any).map((patient: any) => {
        return {
          value: patient.memId,
          label: patient.memberName,
        };
      }),
    );
  }

  const getNameForBody = (patientMemId: any) => {
    let result = '';
    patients.patients.forEach((el: any) => {
      if (el.memId === patientMemId) {
        result = el.memberName;
      }
    });
    return result;
  };

  // get coverages/medicalActs map from backend
  async function getExpenses(buId: any, benNbr: any) {
    const response: any = await get(
      uriIreneCoverages(buId, benNbr),
      false,
      0,
      featureName,
    );

    setProcsToValidate(response?.data?.items);
    const coveragesMap = createCoveragesMap(response?.data?.items);
    setCoveragesMap(coveragesMap);

    setCoverageOptions(
      Object.keys(coveragesMap).map((key) => {
        const coverage = coveragesMap[key];
        return {
          value: coverage.catCode,
          label: coverage.catCodeDesc,
        };
      }),
    );
  }

  useEffect(() => {
    getExpenses(patients.buId, patients.benNbr);
    getPatientOptions();
    window.addEventListener('mousemove', () => {});
    window.scrollTo(0, 150);

    // returned function will be called on component unmount
    return () => {
      setWizard({});
      window.removeEventListener('mousemove', () => {});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValidationSchema(newValidationSchema);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files, preRefundFiles, preRefunded, expensesLabel]);

  async function validateForm() {
    if (!!formikContext) {
      const result = await formikContext.validateForm();
      if (Object.keys(result).length > 0) {
        // Invalid form
        setValid(false);
      }
    }
  }

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validationSchema]);

  useEffect(() => {
    renderMedicalActsLabels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expensesLabels]);

  const validateSelectedPatient = async (patient: any) => {
    setPatient(patient);
    const canSubmitRefunds = await validateIban(patient);
    if (!canSubmitRefunds) {
      setShowSpecificErrorMessageModal(true);
    }
  };

  const getTitular = async (selectedMember: any) => {
    try {
      let titular: any = await get(
        uriGetTitular(selectedMember.buId, selectedMember.famId),
        false,
        0,
        featureName,
      );
      if (titular?.data) {
        return titular?.data;
      }
      return {iban: {}};
    } catch {}
  };

  // IBAN INTERNACIONAL
  const validateIban = async (patientSelected: any) => {
    var canProceed = true;
    const createRefundActive = busFuncMap[patientSelected.buId]?.find(
      (func: any) =>
        func?.featureTemplateAlias === functionalitiesAliasMap.createRefund &&
        func?.isVisible,
    );

    const ibanFunc = busFuncMap[patientSelected.buId]?.find(
      (func: any) => func.featureTemplateAlias === functionalitiesAliasMap.iban,
    );

    const ibanFuncActive = ibanFunc?.isVisible;

    const ibanIsEnabledStr = ibanFunc.labels?.find(
      (str: any) => str.labelTemplateAlias === 'ibanRefunds_ibanIsEnabled',
    );
    const bankAccountDataHolder = ibanFunc.labels?.find(
      (str: any) =>
        str.labelTemplateAlias === 'ibanRefunds_bankAccountDataHolder',
    );
    const bankAccountDataRequired = ibanFunc.labels?.find(
      (str: any) =>
        str.labelTemplateAlias ===
        'ibanRefunds_bankAccountDataRequiredForRefunds',
    );

    if (!createRefundActive) {
      canProceed = false;
    } else {
      if (!ibanFuncActive) {
        canProceed = true;
      } else {
        if (ibanIsEnabledStr.text === '1') {
          switch (bankAccountDataHolder?.text) {
            case 'SUBSCRIBER': {
              // lógica titular
              switch (bankAccountDataRequired?.text) {
                case '1': {
                  const titularPatientSelected =
                    await getTitular(patientSelected);
                  canProceed = titularPatientSelected?.iban;
                  if (!canProceed) {
                    // se for titular e puder alterar iban
                    if (
                      titularPatientSelected?.memId ===
                        patientSelected?.memId &&
                      titularPatientSelected?.buId === patientSelected?.buId
                    ) {
                      if (ibanIsEnabledStr.text === '1') {
                        setSpecificErrorMessage(
                          <p>
                            {ibanLabels?.ibanRefunds_fillIbanMyData}{' '}
                            <span
                              role="button"
                              onClick={() =>
                                history.push({
                                  pathname: '/perfil',
                                  state: {patientSelected: patientSelected},
                                })
                              }
                              style={{
                                color: buStyles?.primaryColor || colors.blue,
                              }}>
                              {ibanLabels.ibanRefunds_fillIbanMyDataLink}
                            </span>
                          </p>,
                        );
                      } else {
                        //se for titular e não puder alterar iban
                        setSpecificErrorMessage(
                          <p>
                            {
                              ibanLabels?.ibanRefunds_fillIbanAskInsuranceCompany
                            }
                          </p>,
                        );
                      }
                    } else {
                      // se não for titular
                      setSpecificErrorMessage(
                        <p>{ibanLabels?.ibanRefunds_fillIbanAskTitular}</p>,
                      );
                    }
                  }
                  break;
                }
                case '0': {
                  canProceed = true;
                  break;
                }
              }

              break;
            }
            case 'INDIVIDUAL': {
              switch (bankAccountDataRequired?.text) {
                case '1': {
                  // obter iban do paciente selecionado
                  const memberData: any = await get(
                    uriMemberData(
                      patientSelected?.buId,
                      patientSelected?.memId,
                      patientSelected?.famId,
                    ),
                    false,
                    0,
                    featureName,
                  );
                  canProceed = memberData?.data?.iban;
                  setSelectedPatientIban(memberData?.data?.iban);
                  if (!canProceed) {
                    setSpecificErrorMessage(
                      <p>
                        {ibanLabels?.ibanRefunds_fillIbanMyData}{' '}
                        <span
                          role="button"
                          onClick={() =>
                            history.push({
                              pathname: '/perfil',
                              state: {patientSelected: memberData},
                            })
                          }
                          style={{
                            color: buStyles?.primaryColor || colors.blue,
                          }}>
                          {ibanLabels.ibanRefunds_fillIbanMyDataLink}
                        </span>
                      </p>,
                    );
                  }
                  break;
                }
                case '0': {
                  canProceed = true;
                  break;
                }
              }

              break;
            }
          }
        } else {
          canProceed = true;
        }
      }
    }
    return canProceed;
  };

  const handlePatientChange = async (value: any) => {
    const newPatient = patients.patients.find((el: any) => el.memId === value);
    getExpenses(newPatient.buId, newPatient.benNbr);
    await validateSelectedPatient(newPatient);
  };

  const hasErrors = async (expenses: any[], index: number) => {
    try {
      await expensesValidationSchema.validate(expenses[index], {
        abortEarly: false,
      });
      expenses[index].error = {};
      setExpenses(expenses);
      return false;
    } catch (e: any) {
      let newError = {};
      e.inner.forEach((innerError: any) => {
        (newError as any)[innerError.path] = innerError.message;
      });
      expenses[index].error = newError;
      setExpenses(expenses);
      return newError;
    }
  };

  const updateExpense = async (index: number, field: string, value: any) => {
    let newExpenses = [...expenses];
    (newExpenses[index] as any)[field] = value;
    if (field === 'medicalAct') {
      const medicalAct = coveragesMap[
        expenses[index].coverage
      ].medicalActs.find((medicalAct: any) => medicalAct.procCode === value);

      if (medicalAct) {
        (newExpenses[index] as any)['type'] = medicalAct.type;
      }
    }
    const expenseErrors = await hasErrors(newExpenses, index);
    if (expenseErrors) {
      newExpenses[index].error = expenseErrors;
      setExpenses(newExpenses);
      setValid(false);
    } else {
      setExpenses(newExpenses);
    }
  };

  const calculateTotalValue = () => {
    let totalValue: number = 0;
    expenses.forEach((expense) => {
      if (!!expense.value) {
        totalValue += +expense.value;
        totalValue = Math.round((totalValue + Number.EPSILON) * 100) / 100;
      }
    });
    return totalValue;
  };

  const onDeleteInvoice = () => {
    setShowDeleteModal(true);
  };

  const onDelete = (id: string) => {
    let newFiles = [...files];
    newFiles = newFiles.filter((elem) => {
      if (elem.id !== id) {
        return true;
      } else {
        URL.revokeObjectURL(elem.preview);
        return false;
      }
    });
    setFiles(newFiles);
  };

  const onDeletePreRefundFile = (id: string) => {
    let newFiles = [...preRefundFiles];
    newFiles = newFiles.filter((elem) => {
      if (elem.id !== id) {
        return true;
      } else {
        URL.revokeObjectURL(elem.preview);
        return false;
      }
    });
    setPreRefundFiles(newFiles);
  };

  const renderMedicalActsLabels = () => {
    let expensesLabel: string = '';
    const expensesLabelsArray = Array.from(expensesLabels).filter(
      (elem) => !!elem && elem !== '',
    );
    expensesLabelsArray.forEach((elem: string, index: number) => {
      expensesLabel += elem;
      if (
        expensesLabelsArray.length > 1 &&
        index < expensesLabelsArray.length - 1
      ) {
        expensesLabel += ', ';
      } else {
        expensesLabel += '.';
      }
    });
    setExpensesLabel(expensesLabel);
  };

  const reimbursementDataOnChange = useCallback(async (values: any) => {
    // Use the values directly instead of relying on current state
    setNoDocuments(values.noDocuments);
    setNoDocumentsPreRefund(values.noDocumentsPreRefund);
  }, []);

  const onSubmitReimbursementData = async (
    values: any,
    {validateForm, setErrors, setSubmitting: setFormikSubmitting}: any,
  ) => {
    const errors = await validateForm(values);
    if (Object.keys(errors).length > 0) {
      // Set the errors in Formik to trigger the scroll functionality
      setErrors(errors);
      setFormikSubmitting(false);
      return;
    }
    setSubmitting(true);
    const {
      buId,
      memId,
      famId,
      grpId,
      multicode,
      usesMulticode,
      beginDate,
      expDate,
      buName,
    } = patients;

    const selectedContact: any = await get(
      uriMemberData(buId, memId, famId),
      false,
      0,
      featureName,
    );
    const clinicInfoDocs = files.filter(
      (elem) => elem.name === 'Informação Clínica',
    );

    const now = moment();
    const time = now.hour() + ':' + now.minutes();

    const dataSend = {
      patient: selectedContact?.data?.name,
      proceed: {
        procCodeList: expenses.map((expense) => ({
          procCode: expense.medicalAct,
          amtClaimed: expense.value,
          dos: getDateInServerFormat(values.dateOfOcurrence),
        })),
        processNumber: 'string',
      },
      expenses: expenses,
      expensesLabels: expensesLabels,
      dateTime: getDateInServerFormat(values.dateOfOcurrence),
      procedures: procsToValidate,
      currentTime: time,
      patientName: getNameForBody(patient),
    };
    const newExpensesFinal: any[] = [];
    dataSend.procedures.forEach((procedure: any) => {
      dataSend.expenses.forEach((expense: any) => {
        if (
          procedure.catCode === expense.coverage &&
          procedure.procCode === expense.medicalAct
        ) {
          newExpensesFinal.push({
            cover: procedure.catCodeDesc,
            actoMedico: procedure.procCodeDesc,
            amountclaimed: expense.value,
            coverage: expense.coverage,
            medicalAct: expense.medicalAct,
            catName: procedure.catCodeDesc,
            type: expense.type,
          });
        }
      });
    });
    let docs: any[] = [];
    clinicInfoDocs?.map((document) =>
      docs.push({
        filename: document.path,
        filedata: document.preview,
      }),
    );
    invoiceFile.length > 0 &&
      getBase64FromInvoice(invoiceFile)
        .then((allFiles: any) => {
          allFiles?.map((file: any) =>
            docs.push({
              filename: file.path,
              filedata: file.preview,
            }),
          );
          const body = {
            pacientName: getNameForBody(patient),
            buId: buId,
            memId: patient?.memId,
            sessionId: wizard.attachFiles.sessionId,
            preReimbursement: preRefunded,
            hasPreReimbursementAttached:
              preRefunded && preRefundFiles.length > 0,
            clientWithoutPreReimbursementAttach:
              preRefunded && values.noDocumentsPreRefund,
            clientWithoutMedicalPrescription: !preRefunded && noDocuments,
            hasMedicalPrescriptionAttached: !preRefunded && files.length > 0,
            expenseDetails: {
              procCodeList: newExpensesFinal.map((expense) => ({
                medicalActName: expense.actoMedico,
                coverageName: expense.cover,
                procCode: expense.medicalAct,
                amtClaimed: expense.amountclaimed,
                dos: getDateInServerFormat(values.dateOfOcurrence),
                type: expense.type,
                mandatoryMedicalPrescription: expensesLabel !== '',
              })),
              processNumber: '',
            },
            username: user.username,
            user: user.name,
          };

          const currentPatient = patients.patients.find(
            (el: any) => el.memId === patient.memId,
          );
          let patientNif = '';
          if (currentPatient) {
            patientNif = currentPatient.nif;
          }

          let formData = new FormData();
          formData = appendFormData(
            body.expenseDetails,
            'expenseDetails',
            formData,
          );
          formData.append('pacientName', getNameForBody(patient.memId));
          formData.append('patientNif', patientNif);
          formData.append('buId', buId);
          formData.append('memId', patient?.memId);
          formData.append('sessionId', wizard.attachFiles.sessionId);
          formData.append('preReimbursement', String(preRefunded));
          formData.append(
            'hasPreReimbursementAttached',
            String(preRefunded && preRefundFiles.length > 0),
          );
          formData.append(
            'clientWithoutPreReimbursementAttach',
            String(preRefunded && values.noDocumentsPreRefund),
          );
          formData.append(
            'clientWithoutMedicalPrescription',
            String(!preRefunded && noDocuments),
          );
          formData.append(
            'hasMedicalPrescriptionAttached',
            String(!preRefunded && files.length > 0),
          );

          //files attached in step 2
          oldFiles.forEach((el: any, index: number) => {
            const originalFile = el.file;
            const updatedFile = new File(
              [originalFile],
              index.toString().padStart(3, '0') + (el.file?.name || el.path),
              {
                type: originalFile.type,
                lastModified: originalFile.lastModified,
              },
            );
            el.file = updatedFile;
            formData.append('documents', el.file);
          });

          // attached pre-refund files
          preRefundFiles.forEach((doc, index) => {
            const originalFile = doc.file;
            const updatedFile = new File(
              [originalFile],
              (index + oldFiles?.length).toString().padStart(3, '0') +
                doc.file?.name,
              {
                type: originalFile.type,
                lastModified: originalFile.lastModified,
              },
            );
            doc.file = updatedFile;
            formData.append('documents', doc.file);
          });

          // attached files
          files.forEach((doc, index) => {
            const originalFile = doc.file;
            const updatedFile = new File(
              [originalFile],
              (index + oldFiles?.length + preRefundFiles?.length)
                .toString()
                .padStart(3, '0') + doc.file?.name,
              {
                type: originalFile.type,
                lastModified: originalFile.lastModified,
              },
            );
            doc.file = updatedFile;
            formData.append('documents', doc.file);
          });

          formData.append(
            'username',
            isServiaPortal
              ? user.given_name + ' ' + user.family_name
              : user.username,
          );
          formData.append('user', user.name);
          formData.append('email', user.email);
          formData.append('groupId', grpId);
          usesMulticode === 1 && formData.append('multicode', multicode);
          formData.append('usesMulticode', usesMulticode);
          formData.append('buName', buName);
          formData.append('expDate', expDate);
          formData.append('beginDate', beginDate);

          postWithCustomHeaders(
            uriNewExpenseSubmitionToAdvSystem(),
            formData,
            configsAcceptLanguage(featureName),
          )
            .then(() => {
              history.push('/historico-reembolsos/pedido-enviado', dataSend);
            })
            .catch((e: any) => {
              const errMessage = getErrorFromMessage(e.data.result.message);

              setErrorShow(true);
              setModalErrorMessage(errMessage);
            })
            .finally(() => {
              setSubmitting(false);
            });
        })
        .catch(() => {
          setErrorShow(true);
          setSubmitting(false);
        });
  };

  // The message is obtained from the backend error response,
  // so if the error message changes there the string inside the includes method might need to be updated as well
  const getErrorFromMessage = (message: string) => {
    if (message.includes('File name too long')) {
      return labels.createRefund_tooManyCharactersError;
    }

    return labels.createRefund_tryLater;
  };

  const expenseCoverageHandleOnChange = async (
    value: any,
    index: any,
    expense: any,
  ) => {
    await updateExpense(index, 'coverage', value);
    let newExpenses = [...expenses];
    newExpenses[newExpenses.indexOf(expense)].medicalAct = '';
    setExpenses(newExpenses);
    if (createMedicalActOptions(expense.coverage).length === 1) {
      await updateExpense(
        index,
        'medicalAct',
        createMedicalActOptions(expense.coverage)[0].value,
      );
      (formikContext as any).setFieldValue('medicalAct', '');
    }
    (formikContext as any).setFieldValue('coverage', '');
  };

  const medicalActOptionsHandleOnChange = async (index: any, value: any) => {
    await updateExpense(index, 'medicalAct', value);
    (formikContext as any).setFieldValue('medicalAct', '');
  };

  const reimbursementDataFieldHandleOnChange = async (
    value: any,
    index: any,
  ) => {
    if (!value || /^(\d+[.]?\d{0,2})$/gm.test(value)) {
      await updateExpense(index, 'value', value);
    }
  };

  const reimbursementDataFieldOnMouseChange = (e: any, index: any) => {
    defineOnMouseFunctions(e, 'value', index, true);
  };

  const handleDelete = (index: any) => {
    let newExpenses = [...expenses];
    newExpenses.splice(index, 1);
    setExpenses(newExpenses);
  };

  const fieldArrayRender = (arrayHelpers: any) => {
    if (expenses.length > 0) {
      return expenses.map((expense) => {
        const index = expenses.indexOf(expense);
        return (
          <Column>
            {isResponsive && (
              <Column className="reimbursement-data-header-cobertura">
                <Row>
                  <p className="m-0" style={{...fonts.SM}}>
                    {createRefundLabels.createRefund_coverage}*
                  </p>
                </Row>
                <Row
                  onMouseOver={(e) => {
                    defineOnMouseFunctions(e, 'coverage', index);
                  }}>
                  <AppFormSelectField
                    showErrorMessage
                    value={expense.coverage}
                    onChange={async (value: any) =>
                      expenseCoverageHandleOnChange(value, index, expense)
                    }
                    className="reimbursement-data-input"
                    options={coverageOptions}
                    error={(expense.error as any).coverage || !expense.coverage}
                    name={`expenses[${index}].coverage`}
                    handleFormikContext={handleFormikContext}
                  />
                </Row>
              </Column>
            )}
            <Row
              className="reimbursement-data-inputs m-0"
              data-expense-index={index}>
              {!isResponsive && (
                <Column className="reimbursement-data-header-cobertura">
                  <Row>
                    <p className="m-0" style={{...fonts.SM}}>
                      {createRefundLabels.createRefund_coverage}*
                    </p>
                  </Row>
                  <Row
                    onMouseOver={(e) => {
                      defineOnMouseFunctions(e, 'coverage', index);
                    }}>
                    <AppFormSelectField
                      showErrorMessage
                      value={expense.coverage}
                      onChange={async (value: any) =>
                        expenseCoverageHandleOnChange(value, index, expense)
                      }
                      className="reimbursement-data-input"
                      options={coverageOptions}
                      error={
                        (expense.error as any).coverage || !expense.coverage
                      }
                      name={`expenses[${index}].coverage`}
                      handleFormikContext={handleFormikContext}
                    />
                  </Row>
                </Column>
              )}

              <Row className="reimbursement-data-header-others">
                <Column className="reimbursement-data-header-atomedico">
                  <Row>
                    {' '}
                    <p
                      className="reimbursement-data-header"
                      style={{...fonts.SM}}>
                      {createRefundLabels.createRefund_medicalAct}*
                    </p>
                  </Row>
                  <Row
                    onMouseOver={(e) => {
                      defineOnMouseFunctions(e, 'medicalAct', index);
                    }}>
                    <AppFormSelectField
                      showErrorMessage
                      value={expense.medicalAct || ''}
                      onChange={async (value: any) =>
                        medicalActOptionsHandleOnChange(index, value)
                      }
                      className="reimbursement-data-input w-100"
                      options={createMedicalActOptions(expense.coverage)}
                      error={
                        (expense.error as any).medicalAct ||
                        (!expense.medicalAct &&
                          createMedicalActOptions(expense.coverage).length !==
                            1)
                      }
                      name={`expenses[${index}].medicalAct`}
                      handleFormikContext={handleFormikContext}
                    />
                  </Row>
                </Column>

                <Column className="reimbursement-data-header-column">
                  <Row>
                    <p
                      className="reimbursement-data-header"
                      style={{...fonts.SM}}>
                      {createRefundLabels.createRefund_value}*
                    </p>
                  </Row>
                  <Row className="input-field">
                    <AppFormField
                      showErrorMessage
                      value={expense.value}
                      onChange={async (value: any) =>
                        reimbursementDataFieldHandleOnChange(value, index)
                      }
                      className="reimbursement-data-input-value"
                      name={`expenses[${index}].value`}
                      error={(expense.error as any).value || !expense.value}
                      handleFormikContext={handleFormikContext}
                      onMouseOver={(e) =>
                        reimbursementDataFieldOnMouseChange(e, index)
                      }
                    />
                  </Row>
                </Column>
              </Row>
              {!isResponsive && (
                <Column className="reimbursement-data-header-icon">
                  <Icon
                    onClick={() => handleDelete(index)}
                    className="delete-icon"
                    name={Icons.CLOSE_CIRCLE}
                    color={colors.black}></Icon>
                </Column>
              )}
            </Row>

            {isResponsive && (
              <Column className="reimbursement-data-header-icon">
                <Icon
                  onClick={() => handleDelete(index)}
                  className="delete-icon"
                  name={Icons.CLOSE_CIRCLE}
                  color={colors.black}></Icon>
              </Column>
            )}
            <Row className="reimbursement-data-white-row"></Row>
          </Column>
        );
      });
    } else {
      let newExpenses = [...expenses];
      newExpenses.push({
        id: createGUID(),
        coverage: '',
        medicalAct: '',
        error: {},
        type: '',
      });
      setExpenses(newExpenses);
      return null;
    }
  };

  const renderCustomButton = () => {
    return (
      <Row className="reimbursement-data-add-row-custom-button">
        <span className="reimbursement-data-submit-button">
          <Row>
            <p
              className="attach-files-title"
              style={{
                ...fonts.L,
                ...fonts.Medium,
                color: colors.black,
                flex: 1,
              }}>
              {createRefundLabels.createRefund_addClinicInfo}
            </p>
            <Icon
              className="responsive-plus-icon"
              name={Icons.PLUS}
              width={'26'}
              height={'26'}
              strokeWidth={'0.5'}
              style={{
                ...fonts.M,
                color: buStyles?.primaryColor || colors.blue,
              }}></Icon>
          </Row>
        </span>
      </Row>
    );
  };

  /**
   *
   * @param isPreRefundCheckbox - Used to figure out which checkbox behavior should be used in the DragDrop component
   * @returns JSX.Element
   */
  const renderAddClinicInfo = (isPreRefundCheckbox: boolean) => {
    // Use separate state for each section to avoid cross-contamination
    const currentFiles = isPreRefundCheckbox ? preRefundFiles : files;
    const setCurrentFiles = isPreRefundCheckbox ? setPreRefundFiles : setFiles;
    const fieldName = isPreRefundCheckbox
      ? 'noDocumentsPreRefund'
      : 'noDocuments';
    const currentOnDelete = isPreRefundCheckbox
      ? onDeletePreRefundFile
      : onDelete;
    const currentNoDocuments = isPreRefundCheckbox
      ? noDocumentsPreRefund
      : noDocuments;

    return (
      <Column
        className={
          preRefunded
            ? 'attach-files-container-pre-refunded attach-files-container-reimbursement-request-confirm'
            : 'attach-files-container attach-files-container-reimbursement-request-confirm'
        }>
        {!isResponsive && (
          <Header2
            className="attach-files-title"
            style={{...fonts.L, ...fonts.Medium, color: colors.black}}>
            {createRefundLabels.createRefund_addClinicInfo}
          </Header2>
        )}
        {isResponsive && (
          <>
            <AppDragDropFileInput
              files={currentFiles}
              setFiles={setCurrentFiles}
              hidePreviews={true}
              newFilesName={'Informação Clínica'}
              name={fieldName}
              customResponsiveButton={renderCustomButton}
            />
          </>
        )}
        {(isPreRefundCheckbox || !preRefunded) && (
          <Row className="attachments-message-container">
            <Icon
              className={
                currentNoDocuments || currentFiles.length > 0
                  ? 'alert-problem-icon-no-documents'
                  : 'alert-problem-icon'
              }
              name={Icons.ALERT_PROBLEM}
              width="24"
              height="24"
              changeViewbox={false}
            />
            {isPreRefundCheckbox ? (
              <span
                className={
                  currentNoDocuments || currentFiles.length > 0
                    ? 'alert-no-documents'
                    : 'alert-text'
                }
                style={{...fonts.M}}>
                {`${createRefundLabels.createRefund_preComparticipationAttachments1} `}
                <span
                  onClick={() => setShowDeclarationInfo(true)}
                  className="declaration-text-click"
                  style={{
                    color: buStyles?.primaryColor || colors.blue,
                  }}>{`${createRefundLabels.createRefund_preComparticipationAttachmentsHighlighted} `}</span>
                {`${createRefundLabels.createRefund_preComparticipationAttachments2}`}
              </span>
            ) : (
              <span
                className={
                  currentNoDocuments || currentFiles.length > 0
                    ? 'alert-no-documents'
                    : 'alert-text'
                }
                style={isResponsive ? {...fonts.MM} : {...fonts.M}}>
                {expensesLabel !== '' &&
                  `${createRefundLabels?.createRefund_include} ${expensesLabel}`}
                {/* {`${createRefundLabels.createRefund_include_prescription}`}s */}

                {/* Keeping this here for now in case we need to revert */}
                {/* {expensesLabel !== ''
                  ? `${createRefundLabels?.createRefund_include} ${expensesLabel}`
                  : `${createRefundLabels.createRefund_include_prescription}`} */}
              </span>
            )}
          </Row>
        )}
        {/* copied the checkbox code that is inside appdragdrop to here because in responsive it must appear after the info text, which is rendered outside the appdradrop component. In non-responsive this checkbox is inside the component (as it should be...)*/}
        {isResponsive && (
          <>
            <Row>
              <div
                style={{
                  textAlign: 'center',
                  marginTop: 15,
                  opacity: currentFiles.length > 0 ? 0.5 : 1,
                }}>
                <AppFormCheckboxField
                  showErrorMessage={true}
                  disabled={currentFiles.length > 0}
                  style={{
                    justifyContent: 'center',
                    paddingTop: 30,
                  }}
                  name={fieldName}
                  label={
                    <span
                      style={{
                        ...fonts.SM,
                        ...(isPreRefundCheckbox ? {} : {paddingTop: 2}),
                      }}>
                      {isPreRefundCheckbox
                        ? createRefundLabels.createRefund_preComparticipationAttachmentsCheckbox
                        : createRefundLabels.createRefund_checkboxClinicDocuments}
                    </span>
                  }
                />
              </div>
            </Row>
            <div className="checkbox-divider"></div>
          </>
        )}
        <Row className="reimbursement-data-add-files-subtitle"></Row>
        {currentFiles.length > 0 && (
          <Row className="app-row">
            <div className="reimbersement-step3-files-container reimbursement-data-attachfilerow reimbursement-data-file-preview">
              {currentFiles.map((item: any) => (
                <AppFilePreview
                  displayQuantity={false}
                  name={
                    isPreRefundCheckbox
                      ? createRefundLabels.createRefund_preComparticipationAttachmentsHighlighted
                      : createRefundLabels.createRefund_clinicInfo
                  }
                  // deleteAll
                  file={item}
                  files={currentFiles}
                  onDelete={() => currentOnDelete(item.id)}
                  scope="createRefund"
                />
              ))}
            </div>
          </Row>
        )}
        {!isResponsive && (
          <div className="app-drag-drop-container">
            <AppDragDropFileInput
              files={currentFiles}
              checkboxPreRefund={isPreRefundCheckbox}
              checkbox={
                !isPreRefundCheckbox && !preRefunded && expensesLabel !== ''
              }
              setFiles={setCurrentFiles}
              hidePreviews={true}
              newFilesName={'Informação Clínica'}
              name={fieldName}
              customResponsiveButton={renderCustomButton}
              submitCount={submitCountForDND}
            />
          </div>
        )}
        {/* </Row> */}
        {renderInfoModal()}
      </Column>
    );
  };

  const renderInfoModal = () => {
    return (
      <div className="myProfilePopup-modal-content p-0">
        <ModalTemplate
          className="myProfilePopup-modal"
          show={showDeclarationInfo}
          onHide={() => setShowDeclarationInfo(false)}
          cross={true}
          hideFooter={true}>
          <Column className="myProfilePopup-column">
            <Row className="myProfilePopup-title-row">
              <p
                style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
                className="p-myProfilePopup">
                {
                  createRefundLabels.createRefund_preComparticipationAttachmentsHighlighted
                }
              </p>
            </Row>
            <Row className="myProfilePopup-paragraph">
              <Column>
                <Row className="myProfile-text-row">
                  <span className="paragraph-text" style={{...fonts.MM}}>
                    {
                      createRefundLabels.createRefund_preComparticipationDialogSubtitle
                    }
                  </span>
                </Row>
              </Column>
            </Row>
            <Row className="myProfilePopup-button">
              <AppButton
                onClick={() => setShowDeclarationInfo(false)}
                variant="inverted"
                className="legal-info-confirm">
                {createRefundLabels.createRefund_popupConfirm}
              </AppButton>
            </Row>
          </Column>
        </ModalTemplate>
      </div>
    );
  };

  const handleAddExpenses = () => {
    let newExpenses = [...expenses];
    newExpenses.push({
      id: createGUID(),
      coverage: '',
      medicalAct: '',
      error: {},
    });
    setExpenses(newExpenses);
    (formikContext as any).setFieldValue('coverage', '');
    (formikContext as any).setFieldValue('medicalAct', '');
  };

  const createPreRefundedOptions = () => {
    let options = [];

    options.push({
      value: 'true',
      label: createRefundLabels.createRefund_preComparticipationQuestionYes,
    });

    options.push({
      value: 'false',
      label: createRefundLabels.createRefund_preComparticipationQuestionNo,
    });

    return options;
  };

  const handleOnCheckboxChange = (value: string) => {
    setPreRefunded(value === 'true');
    setShowRefundData(true);
    setFiles([]);
    setPreRefundFiles([]);
  };

  if (submitting) {
    return <AppSpinner />;
  }

  return (
    <>
      {preRefundFuncAtiva && (
        <>
          <Row className="pre-refunded-message-container">
            <Header2
              className="pre-refunded-title"
              style={{...fonts.ML, ...fonts.Bold, color: colors.black}}>
              {createRefundLabels.createRefund_preComparticipationQuestion}
            </Header2>
          </Row>
          <Row className="pre-refunded-subtitle-container">
            <span
              className="pre-refunded-subtitle"
              style={{...fonts.MM, color: colors.black}}>
              {createRefundLabels.createRefund_preComparticipationDescription}
            </span>
          </Row>
          <Row className="checkbox-container">
            <AppRadioSelectInput
              value={preRefunded}
              options={createPreRefundedOptions()}
              rowDirection={!isResponsive}
              onChange={(value) => handleOnCheckboxChange(value)}
              className="checkbox-input"
            />
          </Row>
        </>
      )}
      <AppForm
        className="patient-validation-form-container"
        initialValues={{
          patient: patients.memId,
          dateOfOcurrence: defaultDateOfOccurence,
          noDocuments: false,
          noDocumentsPreRefund: false,
          expenses: expenses,
          termsAccepted: false,
        }}
        validationSchema={validationSchema}
        onChange={(values: any) => reimbursementDataOnChange(values)}
        onSubmit={(values, formikHelpers) =>
          onSubmitReimbursementData(values, formikHelpers)
        }
        refundAutoScroll={true}
        preRefunded={preRefunded}>
        {preRefunded && renderAddClinicInfo(true)}
        {showRefundData && (
          <div className="reimbersement-data-container">
            <Row className="reimbursement-confirm-data">
              <p
                style={{
                  ...fonts.ML,
                  ...fonts.Bold,
                  color: colors.black,
                }}
                className="reimbursement-data-subtitle-desktop">
                {createRefundLabels.createRefund_confirmData}
              </p>
              <p
                style={{
                  ...fonts.ML,
                  ...fonts.Bold,
                  color: colors.black,
                }}
                className="reimbursement-data-subtitle-responsive">
                {createRefundLabels.createRefund_confirmDataResponsive}
              </p>
            </Row>
            <Row className="reimbursement-data-firstrow">
              <Column className="reimbursement-data-firstrow-column-gradient">
                <Row className="reimbursement-data-firstrow-column-firstrow">
                  <p style={{...fonts.SM}}>
                    {createRefundLabels.createRefund_patient}*
                  </p>
                </Row>
                <Row>
                  <AppFormSelectField
                    showErrorMessage
                    inputStyle={{
                      ...fonts.Bold,
                      color: buStyles?.primaryColor || colors.blue,
                    }}
                    className="reimbursement-data-input w-100"
                    name={'patient'}
                    onChange={(value) => handlePatientChange(value)}
                    options={patientOptions}
                    handleFormikContext={
                      handleFormikContext
                    }></AppFormSelectField>
                </Row>
              </Column>

              <Column className="reimbursement-data-firstrow-column-gradient">
                <Row className="reimbursement-data-firstrow-column-firstrow">
                  <p style={{...fonts.SM}}>
                    {createRefundLabels.createRefund_occurenceDate}*
                  </p>
                </Row>
                <Row className="date-picker-row">
                  <AppFormDatePickerField
                    showErrorMessage
                    minDate={
                      new Date(createRefundLabels.createRefund_date_limit_exact)
                    }
                    maxDate={new Date()}
                    className="reimbursement-data-input"
                    name="dateOfOcurrence"
                    onChange={(value) =>
                      handleDatePickerChange(value)
                    }></AppFormDatePickerField>
                </Row>
              </Column>
              <Column className="reimbursement-data-firstrow-column-gradient reimbursement-data-file-preview">
                {invoiceFile.length > 0 && (
                  <AppFilePreview
                    displayQuantity={true}
                    name={createRefundLabels.createRefund_invoice}
                    deleteAll
                    file={invoiceFile[0]}
                    files={invoiceFile}
                    onDelete={onDeleteInvoice}
                    scope="createRefund"
                  />
                )}
              </Column>
            </Row>

            <Column className="reimbursement-data-secondrow-gradient p-4">
              <FieldArray
                name="expenses"
                render={(arrayHelpers) => fieldArrayRender(arrayHelpers)}
              />
              <Row className="reimbursement-data-add-row">
                <button className="reimbursement-data-submit-button">
                  <Row>
                    <Icon
                      name={Icons.PLUS}
                      width={'26'}
                      height={'26'}
                      strokeWidth={'0.5'}
                      style={{
                        ...fonts.M,
                        color: buStyles?.primaryColor || colors.blue,
                      }}></Icon>
                    <p
                      style={{
                        ...fonts.MM,
                        ...fonts.Bold,
                        color: buStyles?.primaryColor || colors.blue,
                      }}
                      onClick={() => handleAddExpenses()}>
                      {createRefundLabels.createRefund_addInformation}
                    </p>
                  </Row>
                </button>
              </Row>
              <Row className="reimbursement-data-white-row"></Row>

              {!isResponsive && (
                <Row
                  className="reimbursement-data-lastrow"
                  style={{backgroundColor: colors.backgroundGrey}}>
                  <Column className="reimbursement-data-lastrow-column-first">
                    {displayIban && (
                      <>
                        <Row style={{...fonts.M, ...fonts.Light}}>
                          {createRefundLabels.createRefund_iban}:
                        </Row>
                        <Row
                          className="reimbursement-data-iban-row"
                          style={{...fonts.M, ...fonts.Medium}}>
                          {ibanMessage}
                        </Row>
                        <Row className="reimbursement-data-popup-row">
                          <span
                            role="button"
                            style={{
                              ...fonts.M,
                              ...fonts.SemiBold,
                              color: buStyles?.primaryColor || colors.blue,
                            }}
                            onClick={() => setShowKnowMoreModal(true)}>
                            {createRefundLabels.createRefund_know_more}
                          </span>
                        </Row>
                      </>
                    )}
                  </Column>

                  <Column className="reimbursement-data-lastrow-column-second">
                    <Row className="reimbursement-data-lastrow-column-second-row m-0">
                      <div
                        style={{
                          ...fonts.M,
                          ...fonts.Bold,
                          color: colors.black,
                        }}>
                        {createRefundLabels.createRefund_totalValue}
                      </div>
                    </Row>
                  </Column>
                  <Column className="reimbursement-data-lastrow-column-third">
                    <Row className="justify-content-end m-0">
                      <div
                        style={{
                          ...fonts.ML,
                          ...fonts.Bold,
                          color: colors.black,
                        }}>
                        {formatCurrencyExpenses(
                          calculateTotalValue(),
                          undefined as any, // not needed
                          'createRefund',
                        )}
                      </div>
                    </Row>
                  </Column>
                </Row>
              )}
              {isResponsive && (
                <>
                  <Row>
                    <Column className="reimbursement-data-lastrow-column-second">
                      <Row className="reimbursement-data-lastrow-column-second-row m-0">
                        <div
                          style={{
                            ...fonts.M,
                            ...fonts.Bold,
                            color: colors.black,
                          }}>
                          {createRefundLabels.createRefund_totalValue}
                        </div>
                      </Row>
                    </Column>
                    <Column className="reimbursement-data-lastrow-column-third">
                      <Row className="justify-content-end m-0">
                        <div
                          style={{
                            ...fonts.ML,
                            ...fonts.Bold,
                            color: colors.black,
                          }}>
                          {formatCurrencyExpenses(
                            calculateTotalValue(),
                            undefined as any, // not needed
                            'createRefund',
                          )}
                        </div>
                      </Row>
                    </Column>
                  </Row>

                  {displayIban && (
                    <Row>
                      <Column className="reimbursement-data-lastrow-column-first">
                        <Row style={{...fonts.M, ...fonts.Light}}>
                          {createRefundLabels.createRefund_iban}:
                        </Row>
                        <Row
                          className="reimbursement-data-iban-row"
                          style={{...fonts.M, ...fonts.Medium}}>
                          {ibanMessage}
                        </Row>
                        <Row className="reimbursement-data-popup-row">
                          <span
                            role="button"
                            style={{
                              ...fonts.M,
                              ...fonts.SemiBold,
                              color: buStyles?.primaryColor || colors.blue,
                            }}
                            onClick={() => setShowKnowMoreModal(true)}>
                            {createRefundLabels.createRefund_know_more}
                          </span>
                        </Row>
                      </Column>
                    </Row>
                  )}
                </>
              )}
              {/* /> */}
            </Column>

            {/* {!preRefunded && expensesLabel !== '' && ( */}
            <>{renderAddClinicInfo(false)}</>
            {/* )} */}
            <>
              <div className="terms-accept-container">
                <AppFormCheckboxField
                  showErrorMessage
                  className="terms-accept-checkbox-field"
                  name={'termsAccepted'}
                  label={
                    <span style={{...fonts.SM}}>
                      <p>{createRefundLabels.createRefund_checkConsent}</p>
                      <p>{createRefundLabels.createRefund_checkConsentEnd}</p>
                    </span>
                  }
                />
                <div className="required-fields-container">
                  <Row style={{...fonts.SM}}>
                    {createRefundLabels.createRefund_requiredFields}
                  </Row>
                </div>
              </div>
              <Row className="attach-files-confirm-button-row">
                <AppFormSubmitButton
                  className="attach-files-confirm-button"
                  title={
                    createRefundLabels.createRefund_selectFilesConfirmAndSendButtonText
                  }
                  onClickFunction={() => {
                    setSubmitCountForDND((prev) => prev + 1);
                  }}
                />
              </Row>
            </>
            <ModalTemplate
              show={showDeleteModal}
              className="delete-popup-content"
              onHide={() => setShowDeleteModal(false)}
              cross={true}
              hideFooter={true}
              size="lg">
              <Column>
                <div className="delete-popup-icon">
                  <Icon
                    className="errorPopup-icon"
                    name={Icons.ALERT_PROBLEM}
                    width="18"
                    height="25"
                    color={colors.alertRed}
                  />
                </div>
                <p style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}>
                  {createRefundLabels.createRefund_removeInvoiceTitle}
                </p>
                <p
                  className="remove-invoice-description-p"
                  style={{
                    ...fonts.MM,
                    color: colors.black,
                  }}>
                  {createRefundLabels.createRefund_removeInvoiceDescription}
                </p>
              </Column>
              <Row className="errorPopup-button">
                <AppButton
                  className="health-data-button-yes"
                  onClick={() => {
                    deleteProcess();
                  }}
                  variant="secondary">
                  {createRefundLabels.createRefund_removeInvoiceYes}
                </AppButton>
                <AppButton
                  className="health-data-button-no"
                  onClick={() => {
                    setShowDeleteModal(false);
                  }}
                  variant="secondary">
                  {createRefundLabels.createRefund_removeInvoiceNo}
                </AppButton>
              </Row>
            </ModalTemplate>
            <ModalTemplate
              show={knowMoreModal}
              hideFooter={true}
              onHide={() => {
                setShowKnowMoreModal(false);
              }}
              cross={true}>
              <p
                className="know-more-title"
                style={{...fonts.ML, color: colors.black}}>
                {createRefundLabels.createRefund_iban}
              </p>
              <p style={{...fonts.M}}>
                {/* {createRefundLabels.createRefund_know_more_modal_text} */}
                {knowMoreMessage}
              </p>
              <Row>
                <AppButton
                  onClick={() => {
                    setShowKnowMoreModal(false);
                  }}
                  variant="secondary"
                  className="know-more-submit">
                  {createRefundLabels.createReufund_know_more_modal_ok}
                </AppButton>
              </Row>
            </ModalTemplate>
            {errorShow && (
              <ModalTemplate
                type="error"
                show={errorShow}
                hideFooter={true}
                onHide={() => {
                  setErrorShow(false);
                }}
                cross={true}>
                <p
                  className="submission-problem-p"
                  style={{color: colors.black}}>
                  {labels.createRefund_errorOnReading}
                </p>
                <p>{modalErrorMessage}</p>
                <Row>
                  <AppButton
                    onClick={() => {
                      setErrorShow(false);
                    }}
                    variant="secondary"
                    className="talk-with-us-modal-button">
                    {labels.createRefund_popupConfirm}
                  </AppButton>
                </Row>
              </ModalTemplate>
            )}
            <ModalTemplate
              type="error"
              inputType="confirm"
              show={showSpecificErrorMessageModal}
              onHide={() => {
                setShowSpecificErrorMessageModal(false);
              }}
              cross={false}
              hideFooter>
              <Column>
                <div
                  style={{
                    ...fonts.M,
                    ...fonts.Bold,
                    ...getColor('color', colors.alertRed),
                  }}>
                  {specificErrorMessage}
                </div>
              </Column>
              <AppButton
                onClick={() => {
                  setShowSpecificErrorMessageModal(false);
                  setPatientOptions(
                    patientOptions.filter(
                      (patients) => patients?.value !== patient?.memId,
                    ),
                  );
                }}
                className="button-iban-modal">
                {labels?.createReufund_know_more_modal_ok}
              </AppButton>
            </ModalTemplate>
          </div>
        )}
      </AppForm>
    </>
  );
}
const mapStateToProps = ({
  user,
  iban,
  wizard,
  strings,
  globalStyles,
  selectedBu,
  patients,
  titular,
  busFuncMap,
  bankAccountDataHolder,
  tenant,
}: any) => ({
  user: user.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  messageLabels: strings.value.pt.messages,
  ibanLabels: strings.value.pt.ibanRefunds,
  titular: titular.value,
  buStyles: globalStyles.value,
  selectedBu: selectedBu.value,
  patients: patients.value,
  busFuncMap: busFuncMap.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
  iban: iban.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIban: (value: any) => dispatch(setIban(value)),
  setTitular: (value: any) => dispatch(setTitular(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(NewReimbursementData),
);
